<template>
  <div class="page-con" :style="{ '--font_color': fontColor }">
    <div>
      <!-- Found over {{ total | FilterNum }}
      {{ keyword != "" ? `"${keyword}"` : `` }} results -->
      {{ (currentPage - 1) * pageSize + 1 }} -
      {{ currentPage * pageSize > total ? total : currentPage * pageSize }} over
      {{ total }} results for {{ keyword != "" ? `"${keyword}"` : `` }}
    </div>
    <div class="flex-center-start">
      <div class="page-text">{{ $t("ListofResults.Rowsperpage") }}:</div>
      <el-select
        v-model="sizePage"
        class="page-size-select"
        @change="selectCurrentItem"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button class="page-btn" :disabled="pageNumber == 1" @click="prevPage">
        <i class="iconfont icon-24gl-arrowLeft"></i>
      </el-button>
      <el-button
        class="page-btn"
        :disabled="pageNumber == totalPage"
        @click="nextPage"
      >
        <i class="iconfont icon-24gl-arrowRight"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    keyword: {
      type: String,
      default: "",
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    fontColor: {
      type: String,
      default: "#f9722c",
    },
  },
  watch: {
    currentPage: {
      handler(val) {
        this.pageNumber = val;
      },
      immediate: true,
    },
    pageSize: {
      handler(val) {
        this.sizePage = val;
      },
      immediate: true,
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.pageSize);
    },
  },
  data() {
    return {
      pageNumber: 1, //页码
      sizePage: 10, //每页数量
      //   totalPage: 0, //总页数
      options: [
        {
          value: 5,
          label: 5,
        },
        {
          value: 10,
          label: 10,
        },
        {
          value: 15,
          label: 15,
        },
      ],
    };
  },
  methods: {
    // 上一页
    prevPage() {
      this.pageNumber--;
      this.$emit("onPageChange", {
        page: this.pageNumber,
        pageSize: this.sizePage,
      });
    },
    //   下一页
    nextPage() {
      this.pageNumber++;
      this.$emit("onPageChange", {
        page: this.pageNumber,
        pageSize: this.sizePage,
      });
    },
    //切换每页显示条数
    selectCurrentItem(val) {
      this.$emit("onPageChange", { page: 1, pageSize: val });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.page-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;
  margin-top: 14px;
  font-size: 14px;
  color: #666666;
}
.page-text {
  margin-right: 6px;
  font-size: 14px;
  color: #666666;
}
.page-size-select {
  width: 50px;
  height: 24px;
  margin-right: 20px;
}

.page-size-select >>> .el-input__inner {
  padding: 0 20px 0 6px;
  line-height: 24px;
  font-size: 16px;
  color: var(--font_color);
  text-align: center;
  border-radius: 4px;
  border: 1px solid #cccccc;
}
.page-size-select >>> .el-input__suffix {
  right: 6px;
}
.page-size-select >>> .el-input__icon {
  width: 10px;
  font-size: 12px;
}
.page-btn {
  width: 24px;
  height: 24px;
  min-height: 24px;
  min-width: 24px !important;
  padding: 0;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #cccccc;
}
.page-btn i {
  font-size: 14px;
  color: var(--font_color);
}
.page-btn.is-disabled {
  border-color: #cccccc;
}

.page-btn.is-disabled i {
  color: #dddddd;
}
.page-btn + .page-btn {
  margin-left: 6px;
}
@media (max-width: 1920px) {
  .page-con {
    height: 24px;
    margin-top: 10px;
    font-size: 14px;
  }
  .page-text {
    margin-right: 4px;
    font-size: 14px;
  }
  .page-size-select {
    width: 44px;
    height: 24px;
    margin-right: 14px;
  }
  .page-size-select >>> .el-input__inner {
    padding: 0 14px 0 4px;
    line-height: 24px;
    font-size: 14px !important;
    border-radius: 3px;
    vertical-align: top;
  }
  .page-size-select >>> .el-input__suffix {
    right: 4px;
  }
  .page-size-select >>> .el-input__icon {
    width: 8px;
    margin-right: 2px;
    font-size: 12px;
  }
  .page-btn {
    width: 24px;
    height: 24px;
    min-height: 24px;
    min-width: 24px !important;
    line-height: 22px;
    border-radius: 3px;
  }

  .page-btn i {
    font-size: 12px;
  }
  .page-btn + .page-btn {
    margin-left: 4px;
  }
}
</style>
